import { isSet } from '@core/util/value';

export const exportToCsv = (filename: string, rows: string[][]): void => {
	const csvFile = processData(rows);

	const blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
	const link = document.createElement('a');
	const url = URL.createObjectURL(blob);
	link.href = url;
	link.download = filename;
	link.style.visibility = 'hidden';
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
};

export const processData = (rows: string[][]): string => {
	const processRow = function (row) {
		let finalVal = '';
		for (let j = 0; j < row.length; j++) {
			let innerValue = isSet(row[j]) ? row[j].toString() : '';
			if (row[j] instanceof Date) {
				innerValue = row[j].toLocaleString();
			}
			let result = innerValue.replace(/"/g, '""');
			if (result.search(/("|,|\n)/g) >= 0) result = `"${result}"`;
			if (j > 0) finalVal += ',';
			finalVal += result;
		}

		return `${finalVal}\n`;
	};

	let csvFile = '';
	for (let i = 0; i < rows.length; i++) {
		csvFile += processRow(rows[i]);
	}

	return csvFile;
};

export function verifyProperColumns(body: string): string {
	if (!body.match(/,[\n\r]+/g)) {
		// This is being done in 2 regex calls because replace is adding 2 commas at the end of all but the last line.
		// The first replace adds the commas, and the second removes the extra commas on empty lines.
		body = body.replace(/$/gm, ',').replace(/^,$/gm, '');
	}
	return body;
}
